// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#containerHelp .container {
  align-items: center;
}
#containerHelp .account-modules h1 {
  text-align: left;
}
#containerHelp .title {
  color: #0f5597;
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 30px;
}
#containerHelp .tabhead {
  font-size: 25px;
}
#containerHelp .name {
  font-size: 30px;
  width: 85%;
  top: 1%;
  color: #0b365f;
  font-weight: 500;
  padding-left: 20px;
}
#containerHelp .sub-head-cls {
  color: #059ec0;
  padding-bottom: 3%;
  font-weight: bold;
  font-size: 16px;
}
#containerHelp .pragrph-cls {
  padding-right: 5%;
  white-space: break-spaces;
}
#containerHelp .frm-min-width {
  min-width: 100%;
}
#containerHelp .btn {
  float: left;
  color: #ffffff;
  font-weight: 500;
  font-size: 17px;
  width: 50%;
  height: 80%;
  background: grey;
}
#containerHelp .blu-btn {
  float: right;
  color: #ffffff;
  font-weight: 500;
  font-size: 17px;
  width: 50%;
  height: 80%;
  background: #0f5597;
}
#containerHelp h3 {
  color: #0f5597;
  font-size: 20px;
}
#containerHelp p {
  color: #58595B;
}
#containerHelp .contact-form {
  margin-right: 20px;
}
#containerHelp .contact-form .k-button {
  color: white;
  background-color: #0f5596;
  border-radius: 0px;
  box-shadow: none;
  float: right;
  margin-top: 15px;
  text-transform: unset;
}
#containerHelp .contact-form .k-input,
#containerHelp .contact-form .k-textbox,
#containerHelp .contact-form .k-select {
  background-color: white;
}
#containerHelp .contact-form .k-label {
  color: #58595B;
}
#containerHelp .contact-form .k-form-fieldset {
  background-color: #f9f9f9;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 30px;
  padding-bottom: 30px;
  border: 1px solid #e0e0e0;
}
#containerHelp .m-l-60 {
  margin-left: 60px;
}
#containerHelp .info-text {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
#containerHelp .help-space-between {
  justify-content: space-between;
}
#containerHelp .help-column {
  max-width: 370px;
}
#containerHelp .help-column-min {
  min-width: 370px;
}
@media screen and (max-width: 520) {
  #containerHelp .help-column-min {
    max-width: 100%;
    min-width: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/helps/help/help.component.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AAGI;EACI,gBAAA;AADR;AAII;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAFR;AAKI;EACI,eAAA;AAHR;AAMI;EACI,eAAA;EACA,UAAA;EACA,OAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAJR;AAOI;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AALR;AAQI;EACI,iBAAA;EACA,yBAAA;AANR;AASI;EACI,eAAA;AAPR;AAUI;EACI,WAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AARR;AAWI;EACI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AATR;AAYI;EACI,cAAA;EACA,eAAA;AAVR;AAaI;EACI,cAAA;AAXR;AAcI;EACI,kBAAA;AAZR;AAaQ;EACI,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AAXZ;AAaQ;;;EAGI,uBAAA;AAXZ;AAaQ;EACI,cAAA;AAXZ;AAaQ;EACI,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AAXZ;AAeI;EACI,iBAAA;AAbR;AAgBI;EACI,aAAA;EACA,eAAA;EACA,8BAAA;AAdR;AAiBI;EACI,8BAAA;AAfR;AAkBI;EACI,gBAAA;AAhBR;AAmBI;EACI,gBAAA;AAjBR;AAoBI;EACI;IACI,eAAA;IACA,eAAA;EAlBV;AACF","sourcesContent":["#containerHelp {\n    .container {\n        align-items: center;\n    }\n\n    .account-modules h1 {\n        text-align: left;\n    }\n\n    .title {\n        color: #0f5597;\n        font-size: 28px;\n        font-weight: 500;\n        margin-bottom: 30px;\n    }\n\n    .tabhead {\n        font-size: 25px;\n    }\n\n    .name {\n        font-size: 30px;\n        width: 85%;\n        top: 1%;\n        color: #0b365f;\n        font-weight: 500;\n        padding-left: 20px;\n    }\n\n    .sub-head-cls {\n        color: #059ec0;\n        padding-bottom: 3%;\n        font-weight: bold;\n        font-size: 16px;\n    }\n\n    .pragrph-cls {\n        padding-right: 5%;\n        white-space: break-spaces;\n    }\n\n    .frm-min-width {\n        min-width: 100%;\n    }\n\n    .btn {\n        float: left;\n        color: #ffffff;\n        font-weight: 500;\n        font-size: 17px;\n        width: 50%;\n        height: 80%;\n        background: grey;\n    }\n\n    .blu-btn {\n        float: right;\n        color: #ffffff;\n        font-weight: 500;\n        font-size: 17px;\n        width: 50%;\n        height: 80%;\n        background: #0f5597;\n    }\n\n    h3 {\n        color: #0f5597;\n        font-size: 20px;\n    }\n\n    p {\n        color: #58595B;\n    }\n\n    .contact-form {\n        margin-right: 20px;\n        .k-button {\n            color: white;\n            background-color: #0f5596;\n            border-radius: 0px;\n            box-shadow: none;\n            float: right;\n            margin-top: 15px;\n            text-transform: unset;\n        }\n        .k-input,\n        .k-textbox,\n        .k-select {\n            background-color: white;\n        }\n        .k-label {\n            color: #58595B;\n        }\n        .k-form-fieldset {\n            background-color: #f9f9f9;\n            padding-left: 15px;\n            padding-right: 15px;\n            padding-top: 30px;\n            padding-bottom: 30px;\n            border: 1px solid #e0e0e0;\n        }\n    }\n\n    .m-l-60{\n        margin-left: 60px;\n    }\n\n    .info-text {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n    }\n\n    .help-space-between{\n        justify-content: space-between;\n    }\n\n    .help-column {\n        max-width: 370px;  \n    }\n    \n    .help-column-min {\n        min-width: 370px;  \n    }\n    \n    @media screen and (max-width: 520) {\n        .help-column-min {\n            max-width: 100%;\n            min-width: none;  \n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
